import React from 'react';
import { StyledRadioButton } from './styled';
import { ReactComponent as EquipIcon } from 'assets/icons/equip-icon-gray.svg';
import { ReactComponent as AreaIcon } from 'assets/icons/area-icon-gray.svg';
import { ReactComponent as CheckedIcon } from 'assets/icons/checked-icon-orange.svg';
import { ReactComponent as XIcon } from 'assets/icons/close-gray.svg';
import { ReactComponent as CheckedGrayIcon } from 'assets/icons/checked-icon-sm.svg';
import { ReactComponent as SmileIcon } from 'assets/icons/smile-face-sm.svg';
import { ReactComponent as MehIcon } from 'assets/icons/meh-face-sm.svg';
import { ReactComponent as FrownIcon } from 'assets/icons/frown-face-sm.svg';

const RadioButton = ({ disabled = false, isActive, onClick, text, width, showIcon = false, icon }) => {
  const selectIcon = icon => {
    switch (icon) {
      case 'Equipamento':
        return <EquipIcon />;
      case 'Área':
        return <AreaIcon />;
      case 'IconeX':
        return <XIcon />;
      case 'IconeCheck':
        return <CheckedGrayIcon />;
      case 'SmileIcon':
        return <SmileIcon />;
      case 'MehIcon':
        return <MehIcon />;
      case 'FrownIcon':
        return <FrownIcon />;
      default:
        return;
    }
  };
  return (
    <StyledRadioButton
      disabled={disabled}
      isActive={isActive}
      width={width}
      hasStroke={icon === 'IconeX'}
      onClick={disabled ? null : onClick}
    >
      {isActive && showIcon && <CheckedIcon />}
      {selectIcon(icon)}
      {text}
    </StyledRadioButton>
  );
};

export { RadioButton };
